module.exports = __webpack_public_path__ + "static/media/logo-Pam.2f760455.png";